

































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import UserGroupProvider from "@/components/app/admin/userGroups/userGroupProvider.vue";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";
import IsLoading from "@/components/base/IsLoading.vue";

interface Form {
  name: string;
  functionalities: string[];
}

const initialForm = (): Form => {
  return {
    name: "",
    functionalities: []
  };
};

@Component({
  components: {
    UserGroupProvider,
    IsLoading
  }
})
export default class AddEditUserGroupModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    userGroupProvider: UserGroupProvider;
  };

  // Props

  @Prop({ required: true })
  public userGroupCode!: string;

  @Prop({
    default: () => params => ({
      name: "adminUserGroup",
      params
    })
  })
  public viewRoute!: (params) => { [key: string]: string };

  // Data

  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  public isProcessing = false;

  public get $userGroupData() {
    return this.$refs.userGroupProvider.providerData();
  }

  public get $userGroupMethods() {
    return this.$refs.userGroupProvider.providerMethods;
  }

  public get formIsChanged() {
    return (
      this.initialForm.name !== this.form.name ||
      this.$_.sortBy(this.form.functionalities).join("_") !==
        this.$_.sortBy(this.initialForm.functionalities).join("_")
    );
  }

  public clearRoute(userGroupCode) {
    if (
      [this.viewRoute({ userGroupCode }).name].includes(
        this.$route.name as string
      ) &&
      this.$route.params.userGroupCode === userGroupCode
    ) {
      const path = this.$route.fullPath.replace(userGroupCode, "");
      this.$router.replace(path).catch(err => err);
    }
  }

  public onProviderLoaded() {
    if (this.$userGroupData.canEdit) {
      this.setInitialForm();
    }
  }

  public beforeDestroy() {
    this.clearRoute(this.userGroupCode);
  }

  public setInitialForm() {
    this.form.name = this.$userGroupData.userGroup.name;
    this.form.functionalities = this.$_.map(
      this.$userGroupData.userGroup.functionalities,
      "code"
    );
    this.form = this.$_.cloneDeep(this.form);
    this.$set(this, "initialForm", this.$_.cloneDeep(this.form));
  }

  public async validateBeforeSubmit() {
    if (!this.$userGroupData.canSubmit) {
      return;
    }
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.$userGroupMethods.save(this.form);
      this.initialForm = this.$_.cloneDeep(this.form);
      this.$buefy.toast.open({
        message: this.$t("_sentence.successfully_saved") as string
      });
      this.$emit("close");
      this.$emit("success");
      this.$bus.$emit("admin/userGroups/save", {
        userGroupCode: this.userGroupCode
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
